import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PencilRegularRename from './pencil-regular-rename-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PencilRegularRename {...validProps} />;
}
SvgComponent.iconName = 'pencilRegularRename';

export const PencilRegularRenameIcon = svgIconWrapper(SvgComponent);
